import(/* webpackMode: "eager" */ "/var/www/voiceagent-app/RestroAgent/src/app/forgot-password/page.tsx");
